import { defineAction, object, string, number } from '~/prix'
import variableListAction from './variableList.action.json' assert { type: 'json' }

const variableListDefinition = defineAction({
  ...variableListAction,

  input: object({
    search: string().isOptional(),
    category: string().isOptional(),
    startIndex: number().isOptional(),
    endIndex: number().isOptional(),
  }),
  output: object({}),
  cache: input => {
    if (input.search) {
      return {}
    }

    return {
      back: {},
      front: {
        // 5 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 5,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
    }
  },
})

export default variableListDefinition
